<template>
  <div class="fm-table-menu">
    <fm-btn
      v-for="item in tableActions"
      @clickBtn="clickFmTableMenu(item.key)"
      :btn-label="item.label || item.getLabel(rowData)"
      :btn-status="item.status"
      :key="item.key"
      btn-size="small">
    </fm-btn>
  </div>
</template>

<script>
import FmBtn from './FmBtn'

export default {
  components: {
    FmBtn
  },
  name: 'fm-table-menu',
  props: {
    rowData: {
      type: Object
    },
    field: {
      type: String
    },
    index: {
      type: Number
    }
  },
  computed: {
    tableActions: {
      get () {
        let data = []
        let allAction = this.$parent.$parent.$parent.tableActions
        allAction.forEach((item) => {
          if (!item.show || item.show(this.rowData)) {
            data.push(item)
          }
        })
        return data
      }
    }
  },
  methods: {
    clickFmTableMenu (key) {
      this.$emit('on-custom-comp', {action: key, data: this.rowData})
    }
  }
}
</script>

<style lang="less" scoped>
.fm-table-menu {
  display: flex;
  height: 100%;
  align-items: center;
  a {
    margin: 0.2rem;
  }
}
</style>

<style lang="less">
.fm-table-menu {
  .fm-btn-s {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components_bit/FmTableMenu.vue